import Input from "../../Control/Input";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Wrapper } from "../../Control/Flexbox";
import RefreshIcon from "@material-ui/icons/Refresh";
import { ExpandLess, ExpandMore, Remove, Add } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const ApprovedSupplier = (props) => {
  const { ppapData } = props;
  const [render, setRender] = useState(false);
  const [isSpecs, setIsSpecs] = useState([]);
  const [isSpecs1, setIsSpecs1] = useState([]);
  function handleSpec(e, index) {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    ppapData.las_master[index][e.target.name] = value;
  }
  function handleSpec1(e, index) {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    ppapData.las_secondary[index][e.target.name] = value;
  }

  function append(where, data) {
    ppapData[where].push(data);
    setRender((prev) => !prev);
  }

  function remove(where, index) {
    if (window.confirm("Are you sure you want to delete this?")) {
      ppapData[where].splice(index, 1);
      setRender((prev) => !prev);
    }
  }

  const hideSpecs = (index) => {
    setIsSpecs((prev) => [...prev, index]);
  };
  const hideSpecs1 = (index) => {
    setIsSpecs1((prev) => [...prev, index]);
  };

  const openSpecs = (index) => {
    const values = [...isSpecs];
    const idx = values.indexOf(index);
    values.splice(idx, 1);
    setIsSpecs(values);
  };

  const openSpecs1 = (index) => {
    const values = [...isSpecs1];
    const idx = values.indexOf(index);
    values.splice(idx, 1);
    setIsSpecs1(values);
  };

  return (
    <div className="specs-container" style={{ marginBottom: "3rem" }}>
      <Wrapper>
        <Input
          type="text"
          name="las_reviewed"
          label="Reviewed"
          onChange={(e) => {
            ppapData.las_reviewed = e.target.value;
          }}
          defaultValue={ppapData.las_reviewed}
        />
        <Input
          type="text"
          name="las_approved"
          label="Approved"
          onChange={(e) => {
            ppapData.las_approved = e.target.value;
          }}
          defaultValue={ppapData.las_approved}
        />
      </Wrapper>
      <div>
        <Wrapper
          justify="space-between"
          style={{ borderBottom: "1px solid #c80202" }}
        >
          <p className="card-btn-para" style={{ color: "#c80202" }}>
            • ADD{" "}
            <span style={{ fontWeight: 400, color: "black" }}>
              RAW MATERIAL SUPPLIERS
            </span>
          </p>
          <Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#c80202",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() => {
                append("las_master", {
                  s_no: ppapData.las_master.length + 1,
                });
              }}
              justify="center"
            >
              <Add />
            </Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#151a1d",
                color: "white",
                cursor: "pointer",
              }}
              justify="center"
              onClick={() => {
                ppapData?.las_master?.sort(
                  (a, b) => Number(a.s_no) - Number(b.s_no)
                );
                setRender((prev) => !prev);
              }}
            >
              <RefreshIcon />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </div>

      {ppapData.las_master.map((spec, index) => (
        <div
          key={uuidv4()}
          style={{
            marginBottom: "0.3rem",
            marginTop: "0.6rem",
            padding: "0rem",
            border: "1px solid #f0f2f0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#fafafa",
              alignItems: "center",
            }}
            className="spec-header"
          >
            <Wrapper>
              <Input
                type="Number"
                name="s_no"
                onBlur={(e) => handleSpec(e, index)}
                defaultValue={spec.s_no}
                style={{ width: "80px" }}
              />
              <Wrapper
                justify="center"
                style={{
                  marginLeft: "0.4rem",
                  fontSize: "0.9rem",
                  textTransform: "uppercase",
                }}
              >
                {spec.name}
              </Wrapper>
            </Wrapper>
            <Wrapper>
              {isSpecs.includes(index) ? (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => openSpecs(index)}
                >
                  <ExpandLess />
                </Wrapper>
              ) : (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => hideSpecs(index)}
                >
                  <ExpandMore />
                </Wrapper>
              )}
              <Wrapper
                style={{
                  height: "45px",
                  width: "50px",
                  backgroundColor: "#151a1d",
                  color: "white",
                  cursor: "pointer",
                }}
                justify="center"
                onClick={() => remove("las_master", index)}
              >
                <Remove />
              </Wrapper>
            </Wrapper>
          </div>
          {isSpecs.includes(index) && (
            <div className="specs-field">
              <Wrapper>
                <Input
                  type="text"
                  name="name"
                  placeholder="Name & Address of Raw Material Suppliers"
                  style={{ width: "400px" }}
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.name}
                />
                <Input
                  type="text"
                  name="supplies"
                  placeholder="Supplies"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.supplies}
                />
              </Wrapper>
            </div>
          )}
        </div>
      ))}

      <div>
        <Wrapper
          justify="space-between"
          style={{ borderBottom: "1px solid #c80202" }}
        >
          <p className="card-btn-para" style={{ color: "#c80202" }}>
            • ADD{" "}
            <span style={{ fontWeight: 400, color: "black" }}>
              SUB-CONTRACTORS
            </span>
          </p>
          <Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#c80202",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() => {
                append("las_secondary", {
                  s_no: ppapData.las_secondary.length + 1,
                });
              }}
              justify="center"
            >
              <Add />
            </Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#151a1d",
                color: "white",
                cursor: "pointer",
              }}
              justify="center"
              onClick={() => {
                ppapData?.las_secondary?.sort(
                  (a, b) => Number(a.s_no) - Number(b.s_no)
                );
                setRender((prev) => !prev);
              }}
            >
              <RefreshIcon />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </div>

      {ppapData.las_secondary.map((spec, index) => (
        <div
          key={uuidv4()}
          style={{
            marginBottom: "0.3rem",
            marginTop: "0.6rem",
            padding: "0rem",
            border: "1px solid #f0f2f0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#fafafa",
              alignItems: "center",
            }}
            className="spec-header"
          >
            <Wrapper>
              <Input
                type="Number"
                name="s_no"
                onBlur={(e) => handleSpec(e, index)}
                defaultValue={spec.s_no}
                style={{ width: "80px" }}
              />
              <Wrapper
                justify="center"
                style={{
                  marginLeft: "0.4rem",
                  fontSize: "0.9rem",
                  textTransform: "uppercase",
                }}
              >
                {spec.name}
              </Wrapper>
            </Wrapper>
            <Wrapper>
              {isSpecs1.includes(index) ? (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => openSpecs1(index)}
                >
                  <ExpandLess />
                </Wrapper>
              ) : (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => hideSpecs1(index)}
                >
                  <ExpandMore />
                </Wrapper>
              )}
              <Wrapper
                style={{
                  height: "45px",
                  width: "50px",
                  backgroundColor: "#151a1d",
                  color: "white",
                  cursor: "pointer",
                }}
                justify="center"
                onClick={() => remove("las_secondary", index)}
              >
                <Remove />
              </Wrapper>
            </Wrapper>
          </div>
          {isSpecs1.includes(index) && (
            <div className="specs-field">
              <Wrapper>
                <Input
                  type="text"
                  name="name"
                  placeholder="Name & Address of Sub-Contractors"
                  style={{ width: "400px" }}
                  onBlur={(e) => handleSpec1(e, index)}
                  defaultValue={spec.name}
                />
                <Input
                  type="text"
                  name="type_of_work"
                  placeholder="Type of Work"
                  onBlur={(e) => handleSpec1(e, index)}
                  defaultValue={spec.type_of_work}
                />
              </Wrapper>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default ApprovedSupplier;
